import React, { createContext, useContext, useState, ReactNode } from 'react';

type GridColumns = 2 | 3 | 4;

interface LayoutContextType {
  gridColumns: GridColumns;
  setGridColumns: (columns: GridColumns) => void;
  templateRefreshKey: number;
  triggerTemplateRefresh: () => void;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [gridColumns, setGridColumns] = useState<GridColumns>(4);
  const [templateRefreshKey, setTemplateRefreshKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const triggerTemplateRefresh = () => {
    setTemplateRefreshKey(prev => prev + 1);
  };

  return (
    <LayoutContext.Provider value={{ 
      gridColumns, 
      setGridColumns, 
      templateRefreshKey, 
      triggerTemplateRefresh,
      searchQuery,
      setSearchQuery
    }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
}